import React from 'react';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import s from './FullscreenDeviationPage.scss';
export class FullscreenPage extends React.Component {
    render() {
        const { deviation } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(ActionBar, {
            deviation: deviation
        }));
    }
}
export default FullscreenPage;

//# sourceMappingURL=FullscreenDeviationPage.js.map